import { Row, FlexView, COLORS } from '@cuemath/comps';
import styled, { keyframes } from 'styled-components';

import { ReactComponent as InfoSVG } from 'img/info.svg';
import { ReactComponent as EditSVG } from 'img/edit.svg';
import { TableCell } from 'comps/table';

const FadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const TransferTableRoot = styled.div`
  padding: 24px 16px 16px;
  gap: 16px;
  animation: ${FadeIn} 0.5s ease-in-out;
`;

export const HeaderCard = styled(Row)`
  gap: 4px;
  padding: 0;
`;

export const TableContainer = styled(FlexView)`
  padding: 0;
  margin-top: 16px;
`;

export const StyledTableCell = styled(TableCell)`
  cursor: pointer;
  position: relative;
`;

export const InfoIcon = styled(InfoSVG)`
  width: 100%;
  height: 18px;
  cursor: pointer;
`;

export const EditSlotWrapper = styled(Row)`
  gap: 4px;
`;

export const EditSlotIcon = styled(EditSVG)`
  width: 20px;
  height: 20px;
  cursor: pointer;

  line,
  path {
    stroke: ${COLORS.COLA};
  }
`;

export const SlotsWrapper = styled(Row)`
  padding: 0;
`;
